import { mergeProps } from "react-aria";
import { Input as AriaInput, InputProps } from "react-aria-components";

import { sharedStyles } from "../utils";

export function Input(props: InputProps) {
  return (
    <AriaInput {...mergeProps(props, { className: sharedStyles.input })} />
  );
}
